/* Modello a cascata: ogni opzione e' vincolata solo dalle opzioni che la precedono.
   La prima opzione resta sempre completamente scegliibile; scegliendola, le successive
   si aggiornano e, se la selezione e' diventata impossibile, si spostano da sole sul
   primo valore valido. Evita gli stalli e le combinazioni inesistenti. */
(function(){
  function init(){
    var root = document.querySelector('.product-single[data-product-handle]');
    if(!root) return;
    var handle = root.getAttribute('data-product-handle');
    var selects = [].slice.call(root.querySelectorAll('select[data-index^="option"]'));
    var radios  = [].slice.call(root.querySelectorAll('input.single-option-selector__radio[data-index^="option"]'));
    if(!selects.length && !radios.length) return;
    fetch('/products/' + handle + '.js').then(function(r){ return r.json(); }).then(function(p){
      if(!p.options || p.options.length < 2) return;
      var avail = p.variants.filter(function(v){ return v.available; });
      var SUFFIX = ' \u2014 niedost\u0119pne';
      var busy = false;
      function idxOf(el){ return parseInt(el.getAttribute('data-index').replace('option',''), 10) - 1; }
      function currentSel(){
        var sel = [];
        selects.forEach(function(s){ sel[idxOf(s)] = s.value; });
        radios.forEach(function(i){ if(i.checked) sel[idxOf(i)] = i.value; });
        return sel;
      }
      /* vincolata solo dai livelli precedenti */
      function okPrefix(i, value, sel){
        return avail.some(function(v){
          for(var k = 0; k < i; k++){ if(sel[k] != null && v.options[k] !== sel[k]) return false; }
          return v.options[i] === value;
        });
      }
      function mark(){
        var sel = currentSel();
        selects.forEach(function(s){
          var i = idxOf(s);
          [].forEach.call(s.options, function(o){
            var ok = okPrefix(i, o.value, sel);
            o.disabled = !ok;
            var base = o.textContent.replace(SUFFIX, '');
            o.textContent = ok ? base : base + SUFFIX;
          });
        });
        radios.forEach(function(inp){
          var ok = okPrefix(idxOf(inp), inp.value, sel);
          inp.disabled = !ok;
          inp.classList.toggle('disabled', !ok);
          var lbl = root.querySelector('label[for="' + inp.id + '"]');
          if(lbl) lbl.classList.toggle('disabled', !ok);
        });
      }
      /* sposta i livelli successivi sul primo valore valido */
      function cascade(fromIdx){
        var mosso = false;
        selects.forEach(function(s){
          var i = idxOf(s);
          if(i <= fromIdx) return;
          var sel = currentSel();
          if(okPrefix(i, s.value, sel)) return;
          for(var k = 0; k < s.options.length; k++){
            if(okPrefix(i, s.options[k].value, sel)){
              s.value = s.options[k].value;
              mosso = true;
              break;
            }
          }
        });
        return mosso;
      }
      function refresh(changed){
        if(busy) return;
        busy = true;
        var mosso = false;
        if(changed && changed.tagName === 'SELECT') mosso = cascade(idxOf(changed));
        mark();
        busy = false;
        /* se ho spostato un livello successivo, avviso il tema per aggiornare prezzo e foto */
        if(mosso && selects.length) selects[selects.length - 1].dispatchEvent(new Event('change', {bubbles: true}));
      }
      root.addEventListener('change', function(e){
        var t = e.target;
        if(!t) return;
        var isSel = t.tagName === 'SELECT' && t.getAttribute('data-index');
        var isRad = t.classList && t.classList.contains('single-option-selector__radio');
        if(isSel || isRad) setTimeout(function(){ refresh(t); }, 0);
      });
      refresh(null);
    }).catch(function(){});
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();